module.exports = __webpack_public_path__ + "static/media/mcwp3_book.ca37a00f.jpg";